import { render, staticRenderFns } from "./SelectBankAccount.vue?vue&type=template&id=6c3b966c&"
import script from "./SelectBankAccount.vue?vue&type=script&lang=ts&"
export * from "./SelectBankAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports